// @flow
import typeToReducer from 'type-to-reducer'

import type { ChannelMediaStreams } from '@alphaott/api-client/types/channels'

import { GET_CHANNELS_SOURCES_MAP } from '../../actions/channelSources'

export type ChannelSourcesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: ChannelMediaStreams,
}

const initialState: ChannelSourcesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: null,
  data: {},
}

const channelSources = typeToReducer(
  {
    [GET_CHANNELS_SOURCES_MAP]: {
      LOADING: (state): ChannelSourcesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): ChannelSourcesState => {
        // TODO: data: {channelID: {url: 'https://', meta: {expires: '123123123'}}}
        const data = { ...state.data, ...action.payload.data }
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          isError: false,
          errors: null,
          data,
        }
      },

      ERROR: (state, action): ChannelSourcesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
  },
  initialState,
)

export { channelSources }
